import {
  FormControl, InputLabel, MenuItem, SelectChangeEvent,
  Typography,
} from '@mui/material';
import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { POSITION_CLOSURE_REASON, VIEW_MODE } from '../../../../consts/enums';
import STRING_KEYS from '../../../../language/keys';
import CustomSelect from '../../../CustomSelect';
import CustomTextField from '../../../CustomTextField';
import { style } from './style';

type PositionCloseDialogContentProps = {
  viewMode: ViewMode,
  onChangeValues: (key: string, value: string) => void,
  closureReason: string,
  freeText: string,
}

export const PositionCloseDialogContent = ({
  viewMode,
  onChangeValues,
  closureReason,
  freeText,
}: PositionCloseDialogContentProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const isEditable = viewMode === VIEW_MODE.EDITABLE;

  const options = [
    {
      title: translate(STRING_KEYS.POSITION_CANCELED),
      type: POSITION_CLOSURE_REASON.POSITION_CANCELED,
    },
    {
      title: translate(STRING_KEYS.POSITION_ALREADY_FULFILLED),
      type: POSITION_CLOSURE_REASON.POSITION_ALREADY_FULFILLED,
    },
    {
      title: translate(STRING_KEYS.OTPION_CLOSE_REASON_OTHER),
      type: POSITION_CLOSURE_REASON.OTHER,
    },
  ];

  const renderOptions = () => {
    return options.map((option) => {
      return (
        <MenuItem
          key={ option.type }
          value={ option.type }
        >
          { option.title }
        </MenuItem>
      );
    });
  };
  
  return (
    <>
      <Typography
        variant={ style.Typography.variant }
        sx={ style.Typography.sx }
      >
        {translate(STRING_KEYS.CLOSE_POSITION_DIALOG_SUBTITLE)}
      </Typography>
      <FormControl
        variant={ !isEditable ? 'standard' : 'outlined' }
        fullWidth
        margin="normal"
      >
        <InputLabel id="reason">{translate(STRING_KEYS.SELECT_A_REASON)}</InputLabel>
        <CustomSelect
          viewMode={ viewMode }
          labelId="reason"
          value={ closureReason }
          name="reason"
          onChange={  (e:SelectChangeEvent<unknown>) => {
            onChangeValues('closureReason', e.target.value as string);
          } }
          label={ translate(STRING_KEYS.SELECT_A_REASON) }
        >
          {renderOptions()}
        </CustomSelect>
      </FormControl>
      { closureReason === POSITION_CLOSURE_REASON.OTHER && (
        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
        >
          <CustomTextField
            viewMode={ viewMode }
            value={ freeText }
            label={ translate(STRING_KEYS.PLEASE_TYPE_YOUR_YOUR_OTHER_REASON) }
            name="other"
            onChange={  (e:ChangeEvent<HTMLInputElement>) => {
              onChangeValues('freeText', e.target.value as string);
            } }
          />
        </FormControl>
      ) }
    </>
  );
};
